// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__0OnLT","item":"styles_item__dsz5R","img":"styles_img__h_qqk","button":"styles_button__2VwRZ"};